var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-fab', {
    attrs: {
      "mainBtnColor": "#3599DB",
      "scrollAutoHide": false
    }
  }, [_c('fab-item', {
    attrs: {
      "idx": 0,
      "title": "WMS Wiki",
      "icon": "search",
      "color": "rgba(74, 255, 134, 0.863"
    }
  }), _vm._v(" "), _c('fab-item', {
    attrs: {
      "idx": 1,
      "title": "Support",
      "icon": "help_outline",
      "color": "rgba(255, 74, 74, 0.863)"
    },
    on: {
      "clickItem": _vm.support
    }
  })], 1), _vm._v(" "), (_vm.showModal) ? _c('div', [_c('b-modal', {
    staticClass: "support",
    attrs: {
      "size": "lg",
      "title": "Support Request"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Support Request")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "padding": "2rem 1rem 0rem 1rem"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('support-request')], 1)], 1)])])])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35d2a430", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35d2a430","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/float.vue
// module id = 2097
// module chunks = 0